/* ============================================================
   Fibrolab — mejoras de la página de producto
   1) Barra sticky de "Agregar al carrito"
   2) Productos vistos recientemente (localStorage)
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Helpers ---------- */
  function resizeUrl(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents) {
    var amount = (cents || 0) / 100;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CLP';
    var locale = document.documentElement.lang || 'es-CL';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(amount);
    } catch (e) {
      return '$' + Math.round(amount).toLocaleString('es-CL');
    }
  }

  /* ============================================================
     1) STICKY ADD-TO-CART
     ============================================================ */
  function initStickyATC() {
    var bar = document.querySelector('[data-fb-sticky-atc]');
    if (!bar) return;

    var sectionId = bar.getAttribute('data-section-id');
    var realSubmit = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!realSubmit) return;

    var mainPrice = document.getElementById('price-' + sectionId);
    var stickyPrice = document.getElementById('FbStickyPrice-' + sectionId);
    var stickyImg = document.getElementById('FbStickyImage-' + sectionId);
    var stickyBtn = bar.querySelector('[data-fb-sticky-add]');
    var stickyBtnText = bar.querySelector('.fb-sticky-atc__btn-text');

    // El botón sticky dispara el botón real → reutiliza toda la lógica de Dawn.
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (!realSubmit.hasAttribute('disabled')) realSubmit.click();
      });
    }

    function syncPrice() {
      if (mainPrice && stickyPrice) stickyPrice.innerHTML = mainPrice.innerHTML;
    }

    function syncButton() {
      if (!stickyBtn) return;
      var disabled = realSubmit.hasAttribute('disabled');
      stickyBtn.disabled = disabled;
      bar.classList.toggle('fb-sticky-atc--disabled', disabled);
      if (stickyBtnText) {
        var realText = realSubmit.querySelector('span');
        stickyBtnText.textContent =
          disabled && realText ? realText.textContent.trim() : 'Agregar';
      }
    }

    syncPrice();
    syncButton();

    if (mainPrice) {
      new MutationObserver(syncPrice).observe(mainPrice, { childList: true, subtree: true });
    }
    new MutationObserver(syncButton).observe(realSubmit, {
      attributes: true,
      attributeFilter: ['disabled', 'class'],
      childList: true,
      subtree: true,
    });

    // Cambio de variante → actualizar imagen + re-sincronizar precio/botón.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (variant && variant.featured_media && stickyImg) {
          var preview = variant.featured_media.preview_image;
          var src = preview && preview.src;
          if (src) stickyImg.src = resizeUrl(src, 120);
        }
        setTimeout(function () {
          syncPrice();
          syncButton();
        }, 0);
      });
    }

    // Mostrar la barra solo cuando el usuario ya hizo scroll PAST el botón real.
    // (No basta con que el botón no esté en pantalla: si está más abajo en el fold
    // tampoco debe mostrarse la barra todavía).
    var anchor = realSubmit.closest('.product-form__buttons') || realSubmit;
    var ticking = false;
    function updateVisibility() {
      ticking = false;
      var rect = anchor.getBoundingClientRect();
      var scrolledPast = rect.bottom < 0;
      bar.classList.toggle('is-visible', scrolledPast);
    }
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(updateVisibility);
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateVisibility();
  }

  /* ============================================================
     2) VISTOS RECIENTEMENTE
     ============================================================ */
  var RV_KEY = 'fb_recently_viewed';
  var RV_MAX = 12;

  function getRV() {
    try {
      return JSON.parse(localStorage.getItem(RV_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setRV(arr) {
    try {
      localStorage.setItem(RV_KEY, JSON.stringify(arr));
    } catch (e) {}
  }

  function currentHandle(section) {
    if (section && section.getAttribute('data-current-handle')) {
      return section.getAttribute('data-current-handle');
    }
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function buildCard(handle, product) {
    if (!product) return '';
    var img = product.featured_image ? resizeUrl(product.featured_image, 400) : '';
    var price = formatMoney(product.price);
    var onSale = product.compare_at_price && product.compare_at_price > product.price;
    var compare = onSale ? formatMoney(product.compare_at_price) : '';
    return (
      '<li class="fb-rv__card">' +
        '<a class="fb-rv__link" href="/products/' + handle + '">' +
          (img
            ? '<div class="fb-rv__media"><img src="' + img + '" alt="' + escapeHtml(product.title) +
              '" loading="lazy" width="400" height="400"></div>'
            : '') +
          '<div class="fb-rv__body">' +
            (product.vendor ? '<p class="fb-rv__vendor">' + escapeHtml(product.vendor) + '</p>' : '') +
            '<p class="fb-rv__title">' + escapeHtml(product.title) + '</p>' +
            '<p class="fb-rv__price">' +
              (onSale ? '<s>' + compare + '</s> ' : '') +
              '<span' + (onSale ? ' class="fb-rv__price--sale"' : '') + '>' + price + '</span>' +
            '</p>' +
          '</div>' +
        '</a>' +
      '</li>'
    );
  }

  function fetchCard(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (p) {
        return buildCard(handle, p);
      })
      .catch(function () {
        return '';
      });
  }

  function initRecentlyViewed() {
    var section = document.querySelector('[data-fb-recently-viewed]');
    var handle = currentHandle(section);
    var stored = getRV();

    if (section) {
      var grid = section.querySelector('[data-fb-rv-grid]');
      var limit = parseInt(section.getAttribute('data-limit'), 10) || 4;
      var toShow = stored
        .filter(function (h) {
          return h !== handle;
        })
        .slice(0, limit);

      if (grid && toShow.length > 0) {
        Promise.all(toShow.map(fetchCard)).then(function (cards) {
          var html = cards
            .filter(function (c) {
              return c;
            })
            .join('');
          if (html) {
            grid.innerHTML = html;
            section.hidden = false;
          }
        });
      }
    }

    // Registrar el producto actual para próximas visitas.
    if (handle) {
      var list = stored.filter(function (h) {
        return h !== handle;
      });
      list.unshift(handle);
      setRV(list.slice(0, RV_MAX));
    }
  }

  /* ============================================================
     3) PESTAÑAS DE DETALLES (sección a todo el ancho)
     ============================================================ */
  function initDetailsTabs() {
    var groups = document.querySelectorAll('[data-fb-tabs]');
    Array.prototype.forEach.call(groups, function (group) {
      var tabs = Array.prototype.slice.call(group.querySelectorAll('[data-fb-tab]'));
      var panels = Array.prototype.slice.call(group.querySelectorAll('[data-fb-panel]'));
      if (!tabs.length || !panels.length) return;

      function panelFor(key) {
        return panels.filter(function (p) {
          return p.getAttribute('data-fb-panel') === key;
        })[0];
      }

      function activate(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.classList.toggle('is-active', on);
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p) {
          p.hidden = true;
        });
        var panel = panelFor(tab.getAttribute('data-fb-tab'));
        if (panel) panel.hidden = false;
        if (focus) tab.focus();
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          activate(tab);
        });
        tab.addEventListener('keydown', function (e) {
          var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!dir) return;
          e.preventDefault();
          activate(tabs[(i + dir + tabs.length) % tabs.length], true);
        });
      });

      group.classList.add('is-ready');
      activate(tabs[0]);
    });
  }

  /* ---------- Init ---------- */
  function init() {
    initStickyATC();
    initRecentlyViewed();
    initDetailsTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
